import * as lucideIcons from "lucide-react"
import { twMerge } from "tailwind-merge"
import clsx from "clsx"

export const { ...icons } = lucideIcons

type Icon = keyof typeof icons

interface LucideProps extends React.ComponentPropsWithoutRef<"svg"> {
  icon: string
  title?: string
}

function Lucide(props: LucideProps) {
  const { icon, className, ...computedProps } = props
  const Component = lucideIcons[props.icon] as React.ElementType
  return (
    <Component
      {...computedProps}
      className={twMerge(clsx(["stroke-1.5 mr-2", props.className]))}
    />
  )
}

export default Lucide
